import {
	Button
} from "@mui/material";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	LoginContext,
	LoginContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { findComponentStep } from "../../utils/filter";

export const LogInOutButton: React.FC = () => {
	const { activeStep, onChangeStep, onChangeLogin } = useContext(
		MultistepContext
	) as MultistepContextValues;

	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;

	const { isLogged, onLogout, isCalledFromProfile, setIsCalledFromProfile } =
		useContext(LoginContext) as LoginContextValues;

	const handleClick = () => {
		const loginFromProfileStep = findComponentStep(
			selectedFlow!,
			"LoginFromProfile"
		);
		const loginStep = findComponentStep(selectedFlow!, "Login");

		// If isLogged it means that the user wants to logout
		if (isLogged) {
			// If it's not called from profile and we are in a later step than login, we have to go back to login step
			if (!isCalledFromProfile) {
				if (activeStep > loginStep) onChangeStep(loginStep);
			} else {
				if (activeStep <= 0) onChangeStep(0);
			}

			setIsCalledFromProfile(false);
			onLogout(onChangeLogin);
		} else {
			setIsCalledFromProfile(true);
			onChangeStep(loginFromProfileStep);
		}
	};

	return (
		<Button
			variant="text"
			onClick={handleClick}
			sx={{ fontWeight: 400, alignItems: "center" }}
		>
			{isLogged ? (
				<FormattedMessage id="login.logout" defaultMessage="Cerrar sesión" />
			) : (
				<FormattedMessage id="login.enter" defaultMessage="Iniciar sesión" />
			)}
		</Button>
	);
};